/**
 * アプリケーションのページ定義
 */

// 基本ページ定義
export const BASE_PAGES = [
  { id: 'individualAssignments', name: '個別課題' },
  { id: 'schoolTaskSummary', name: '学校課題一覧' },
  { id: 'quiz', name: 'Web課題' },
];

// 管理者専用ページ定義
export const ADMIN_PAGES = [
  { id: 'QuizManagement', name: 'クイズ作成・管理' },
  { id: 'schoolWork', name: '学校ワーク管理' },
];

/**
 * ユーザーの権限に基づいてページリストを生成
 * @param {boolean} isTeacher - 教師権限を持つか
 * @param {boolean} isMaster - マスター権限を持つか
 * @returns {Array} ページリスト
 */
export const generatePageList = (isTeacher, isMaster) => {
  const pages = [...BASE_PAGES];
  
  if (isTeacher && isMaster) {
    // 管理者専用ページを先頭に追加（逆順で追加）
    pages.unshift(ADMIN_PAGES[1]); // 学校ワーク管理
    pages.unshift(ADMIN_PAGES[0]); // クイズ作成・管理
  }
  
  return pages;
}; 